export const getters = {
  getContentType(state) {
    return state.content;
  },
  getTime(state) {
    return state.time;
  },
  getAge(state) {
    return state.age;
  },
  getLanguage(state) {
    return state.language;
  },
  timeIsSet(state) {
    return state.timeIsSet;
  },
  soundActive(state) {
    return state.soundActive;
  },
  playlist(state) {
    return state.playlist;
  },
  videoIsPaused(state) {
    return state.videoIsPaused;
  },
  videoList(state) {
    return state.videoList;
  },
  isAgeSettingDisplayed(state) {
    return state.isAgeSettingDisplayed;
  },
  ageSettingPath(state) {
    return state.ageSettingPath;
  },
  showExpiration(state) {
    return state.showExpiration;
  },
  displayVideoLoader(state) {
    return state.displayVideoLoader;
  },
  displayLoader(state) {
    return state.displayLoader;
  },
  loadingCards(state) {
    return state.loadingCards;
  },
  focusSettings(state) {
    return state.focusSettings;
  },
  focusLiveLink(state) {
    return state.focusLiveLink;
  },
  focusSearchLink(state) {
    return state.focusSearchLink;
  },
  focusKidjoWorldLink(state) {
    return state.focusKidjoWorldLink;
  },
  activeHeaderNav(state) {
    return state.activeHeaderNav;
  },
  hideMobileCard(state) {
    return state.hideMobileCard;
  },
  getLiveMode(state) {
    return state.activeLiveMode;
  },
  getBannerState(state) {
    return state.activeBanner;
  },
  getHeaderBannerState(state) {
    return state.activeHeaderBanner;
  },
  getSettingsCloseBtnState(state) {
    return state.activSettingsCloseBtn;
  },
  getNotificationVisibility(state) {
    return state.isNotificationVisible;
  }
};
